<template>
  <div style="margin: 0 0 12px;">
    <div class="info-list">
      <div class="info-list-item">
        <span class="info-list-item-title">商品名称：</span>
        <span style="flex: 1">{{breakageForm.commodityName}}</span>
      </div>
      <div class="info-list-item">
        <span class="info-list-item-title">出库数量：</span>
        <span style="flex: 1">{{breakageForm.breakageNum}}</span>
      </div>
      <div class="info-list-item">
        <span class="info-list-item-title">报损原因：</span>
        <span style="flex: 1">{{breakageForm.breakageRemark}}</span>
      </div>
    </div>
<!--    <div class="dialog-footer" style="text-align: center; margin-top: 8px;">-->
<!--      <el-button @click.native="cancel" >取消</el-button>-->
<!--      <el-button type="primary" @click="summit">确定</el-button>-->
<!--    </div>-->
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import {submitAuditStockTake} from "@/api/url";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      breakageForm: this.value.breakageForm,
      id: this.value.id,

    }
  },
  methods: {



    cancel() {
      this.$emit("close");
    },



  },
  mounted() {

  }
}
</script>

<style scoped>
.info-list {
  /*display: flex;*/
  /*flex-direction: column;*/
  /*align-items: center;*/
  border: 1px solid #ebeef5;
  padding: 24px;
}
.info-list-item {
  display: flex;
  align-items: center;
  line-height: 1.8;
}
.info-list-item-title {
  text-align: right;
  margin-right: 8px;
  width: 80px !important;
  white-space: nowrap;
}
</style>
